<div class="modal-header">
    <h4 class="modal-title">Invoice Line</h4>
</div>
<div class="modal-body">
    <dx-form [formData]="invoiceLine" validationGroup="invoiceLineValidationGroup">
        <dxi-item dataField="partNumber" [label]="{text: 'Item'}"> </dxi-item>
        <dxi-item dataField="price" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 2 }, step: 0 }" [isRequired]="true"> </dxi-item>
        <dxi-item dataField="quantity" editorType="dxNumberBox" [editorOptions]="{ step: 0 }" [isRequired]="true"></dxi-item>
        <dxi-item dataField="description" editorType="dxTextArea" [editorOptions]="{ height: '125px' }"> </dxi-item>
        <!-- <dxi-item dataField="notes" editorType="dxTextArea" [editorOptions]="{ height: '125px' }"> </dxi-item> -->
    </dx-form>
</div>
<div class="modal-footer">
    <button  class="btn btn-success" (click)="save()">Save</button>
    <button class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
